import React, { useEffect, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import {
  extractMatricDigits,
  extractAllTeachers,
  calcDisplayNo,
} from "../../AppManager";
import MemberCard from "../../components/MemberCard";
import EmptySearch from "../../components/EmptySearch";
import Filter from "../../components/Filter";
import Pagination from "../../components/Pagination";

function AdminAllTeachers() {
  const { search, record, setShowSearch } = useOutletContext();
  const [teachers, setTeachers] = useState([]);
  const [searchParams] = useSearchParams();
  const classFilter = searchParams.get("trainingClass");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    let page = searchParams.get("page") || 1;
    page = parseInt(page);
    page = page > 0 ? page : 1;

    let limit = searchParams.get("limit") || 10;
    limit = parseInt(limit);
    limit = limit > 0 ? limit : 10;
    setPagination({ page, limit });
  }, [searchParams]);

  useEffect(() => {
    const width = 160;
    const height = 220;
    const pagePadMarginWidth = 20;
    const pagePadMarginHeight = 20;
    setPagination((old) => ({
      ...old,
      limit: calcDisplayNo(
        width,
        height,
        pagePadMarginWidth,
        pagePadMarginHeight
      ),
    }));
    window.addEventListener("resize", () => {
      setPagination((old) => ({
        ...old,
        limit: calcDisplayNo(
          width,
          height,
          pagePadMarginWidth,
          pagePadMarginHeight
        ),
      }));
    });

    return () => {
      window.removeEventListener("resize", () => {
        setPagination((old) => ({
          ...old,
          limit: calcDisplayNo(
            width,
            height,
            pagePadMarginWidth,
            pagePadMarginHeight
          ),
        }));
      });
    };
  }, []);

  useEffect(() => {
    let teachers = extractAllTeachers(record);
    if (classFilter)
      teachers = teachers.filter((dat) => dat.trainingClass === classFilter);
    teachers = teachers.filter(
      (dat) =>
        dat.name.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        dat.matric.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        dat.class.toLowerCase().indexOf(search.toLowerCase()) > -1
    );

    setTeachers(teachers);
  }, [record, classFilter, search]);

  useEffect(() => {
    setShowSearch(true);
  });

  document.title = "All Teachers";

  const { page, limit } = pagination;
  const start = (page - 1) * limit;
  const end = start + limit;

  const teacherElements = teachers
    .slice(start, end)
    .map((dat) => (
      <MemberCard
        key={dat.matric + dat.class}
        name={dat.name}
        image={dat.image}
        matric={dat.matric}
        to={extractMatricDigits(dat.matric)}
        imgfolder="teachers"
      />
    ));

  return (
    <div className="overview-students">
      <h1 className="heading1" style={{ width: "100vw" }}>
        All Teachers
      </h1>
      {teachers.length !== 0 && <Filter classFilter={classFilter} />}
      {teacherElements.length === 0 ? (
        <EmptySearch message={"No Teacher Found"} />
      ) : (
        <>
          {teacherElements}
          <Pagination
            limit={pagination.limit}
            currentPage={pagination.page}
            totalPages={Math.ceil(teachers.length / pagination.limit)}
          />
        </>
      )}
    </div>
  );
}

export default AdminAllTeachers;
